import { ref, shallowRef ,watch} from '@vue/composition-api'
import { PestReportService } from '@/app/reports/pest/services/pest.report.service'


import ReportOptions from '@/views/reports/components/options.js'

const { defaultFromdate, defaultTodate } = ReportOptions()


export default function pestReportLogic() {


  const request = ref({
    page: 1,
    length: 25,
    type: 'pestPlan',
    from: defaultFromdate,
    to: defaultTodate,

    //workDays: ['Saturday','Sunday','Monday','Tuesday','Wednesday','Thursday','Friday'],

    plans: [],
  })

  const report_data = shallowRef(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading=ref(false)

  const getReport = () => {

    errors.value = {}
    loading.value = true

    PestReportService.getReport(request.value)
      .then(res => {
        report_data.value = setRowSummery(res.data.data)
        //report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => loading.value = false)
  }
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  
  watch([sortBy,isSortDirDesc],()=>{
  
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    dataTableloading.value = true

    PestReportService.getReport(request.value)
      .then(res => {
        report_data.value = setRowSummery(res.data.data)
        //report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => dataTableloading.value = false)
  })
  const setRowSummery = (data) => {

    let new_data = [];
    let total_presnt = 0;
    let counter = 0;
    let current_device = "";
   
    for (let i = 0; i < data.length; i++) {


      if (current_device == "") {
        current_device = data[i].device;
      }

      if (current_device == data[i].device) {

        counter += 1;
        total_presnt += parseFloat(data[i].percent);
        //  total_duration=55;
        new_data.push({
          id: i + 1,
          plan:data[i].plan,
          device: data[i].device,
          date:data[i].date,
          percent:data[i].percent,
          shiftStart:data[i].shiftStart,
          shiftEnd:data[i].shiftEnd,
          serveInShiftDuration:data[i].serveInShiftDuration,
          deviceStartShiftTime:data[i].deviceStartShiftTime,
          deviceEndShiftTime:data[i].deviceEndShiftTime,
        
          startStatus:data[i].startStatus,
          endStatus:data[i].endStatus,
          percent:data[i].percent,
         
         

        })
      }
      if (data[i + 1] != undefined && data[i + 1].device != current_device) {
        new_data.push({ id: '#', percent: (total_presnt/counter).toFixed(2)+"% ", groupRow: true })
        current_device = "";
        total_presnt = 0;
        counter = 0;

      }

      else if (i + 1 == data.length) {

        new_data.push({ id: '#', percent: (total_presnt/counter).toFixed(2)+"%", groupRow: true })
        current_device = "";
        total_presnt = 0;
        counter = 0;
      }


    }
    
    return new_data;
  }
  const getReportForPdf = () => {
    return new Promise((r, j) => {

      let reportreq=request.value;
      reportreq.type="pestReport"
      PestReportService.getReport(Object.assign(reportreq, {
        page: 1, length: 50000
      })).then(res => r(res.data.data))
    })
  }


  return {
    getReport, getReportForPdf,
    report_data,
    total, from, to,
    request,
    loading,
    errors,
    sortBy,
    isSortDirDesc,
    dataTableloading

  }
}
